import React from 'react';
import { BaseComponentProps } from '../../types';
import Header from '../Header';

interface LayoutProps extends BaseComponentProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children, className = '' }) => {
  return (
    <div className={`h-screen overflow-hidden bg-gray-50 dark:bg-dark-background ${className}`}>
      {/* Header - Fixed at top */}
      <div className='z-50'>
        <Header />
      </div>

      {/* Page content - Fill remaining height, children handle own scroll */}
      <div className='h-[calc(100vh-4rem)]'>{children}</div>
    </div>
  );
};

export default Layout;
